"use client";

import { useState } from "react";
import Image from "next/image";

type NecklaceSizeChartProps = {
  imageSrc?: string;
  imageAlt?: string;
};

export function NecklaceSizeChart({
  imageSrc = "/necklace_sizing_chart.png",
  imageAlt = "Necklace sizing chart"
}: NecklaceSizeChartProps) {
  const [open, setOpen] = useState(false);

  return (
    <div className="border-t border-slate-200">
      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        className="flex w-full items-center justify-between px-0 py-4 text-sm font-medium text-slate-900 transition hover:text-slate-600"
        aria-expanded={open}
      >
        <span>Size Chart</span>
        <span className="text-lg leading-none text-slate-500">{open ? "−" : "+"}</span>
      </button>

      {open && (
        <div className="pb-4">
          <Image
            src={imageSrc}
            alt={imageAlt}
            width={1200}
            height={800}
            className="h-auto w-full object-contain"
          />
        </div>
      )}
    </div>
  );
}
